var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"text-muted text-center"},[_vm._v(" "+_vm._s(_vm.$t('COPYRIGHT_TEXT'))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }